/**
 * Hush wardrobe at the layered-extras seam (batch-003 `adapter.ts`). GhostRenderer imports this in place of
 * `renderHumanoidExtras`; extras without `hushWardrobe` return the owner's output unchanged.
 */
import type { ShapeType } from '../AppearanceDefinitions';
import { renderHumanoidExtras, type ExtrasContext, type LayeredContent } from '../parts/humanoid/HumanoidExtras';
import type { HumanoidExtras } from '../parts/humanoid/HumanoidTypes';
import { buildWardrobePieces } from './pieces';
import { validateConfig } from './validate';

export function renderHumanoidExtrasWithHush(extras: HumanoidExtras, shape: ShapeType, ctx: ExtrasContext): LayeredContent {
  const config = extras.hushWardrobe;
  if (!config) return renderHumanoidExtras(extras, shape, ctx);
  const c = validateConfig(config);
  const pieces = buildWardrobePieces(c, shape, ctx);
  const mallow = c.recipe.params.look === 'mallow';
  // Reuse the owner's rear cloak drape as a shawl; its high mantle would cross the chin.
  const out = { ...renderHumanoidExtras(mallow ? { ...extras, cloak: undefined } : extras, shape, ctx) };
  if (mallow && extras.cloak) out.back += renderHumanoidExtras({ cloak: extras.cloak }, shape, ctx).back;
  for (const p of pieces) out[p.slot] += `${p.defs ? `<defs>${p.defs}</defs>` : ''}${p.body}`;
  return out;
}
